import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { WorkoutProvider } from './contexts/WorkoutContext';

// Landing Page
import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import Register from './pages/Register';

// App Pages
import MainLayout from './layouts/MainLayout';
import Dashboard from './pages/Dashboard';
import WorkoutLibrary from './pages/WorkoutLibrary';
import WorkoutDetail from './pages/WorkoutDetail';
import CalorieCalculator from './pages/CalorieCalculator';
import AICoach from './pages/AICoach';
import ProgressTracker from './pages/ProgressTracker';
import Profile from './pages/Profile';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div className="loading-screen">Загрузка...</div>;
  }

  return isAuthenticated ? children : <Navigate to="/login" />;
};

function AppRoutes() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />

      {/* Protected App Routes */}
      <Route
        path="/app"
        element={
          <ProtectedRoute>
            <MainLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="workouts" element={<WorkoutLibrary />} />
        <Route path="workouts/:id" element={<WorkoutDetail />} />
        <Route path="calculator" element={<CalorieCalculator />} />
        <Route path="coach" element={<AICoach />} />
        <Route path="progress" element={<ProgressTracker />} />
        <Route path="profile" element={<Profile />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <WorkoutProvider>
          <div className="App">
            <AppRoutes />
          </div>
        </WorkoutProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
